"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateComparison_1 = __importDefault(require("../../Util/dateComparison"));
const mostRecentStartOfWeek_1 = __importDefault(require("../../Util/mostRecentStartOfWeek"));
const getDatesOfDateRange_1 = require("../../Util/getDatesOfDateRange");
const RangeUtils_1 = require("../../Util/RangeUtils");
class NutritionCache {
    constructor(strategy, compositeCache, dateTimeProvider, dateTimeModifier, unitMutable) {
        this.getDay = async (customerId, systemDate, getRequest) => await this.strategy.get(`NUTRITION_DAY.${customerId}.${systemDate}`, async () => (0, dateComparison_1.default)(this.lastWeekMonday(), systemDate) !== 1, getRequest);
        this.getNutritionDateRangeKey = (customerId, date) => {
            return `NUTRITION_DATE_RANGE.${customerId}.${this.unitMutable.get()}.${date}`;
        };
        this.getDaysFromRange = (customerId, dateRange, getRequest) => {
            const keys = (0, getDatesOfDateRange_1.getDatesOfDateRange)(dateRange).map((date) => this.getNutritionDateRangeKey(customerId, date));
            return this.compositeCache.get(keys, getRequest, this.denormalized(customerId), this.normalized);
        };
        this.denormalized = (customerId) => (denormalized) => {
            const map = new Map();
            denormalized.days.forEach((day) => {
                map.set(this.getNutritionDateRangeKey(customerId, day.date), day);
            });
            return map;
        };
        this.normalized = (normalized) => {
            return {
                days: [...normalized.values()],
            };
        };
        this.getCalorieBudgetKey = (customerId, range) => {
            return `CALORIE_BUDGET_WEEK_RANGE.${this.unitMutable.get()}.${customerId}.${range}`;
        };
        this.getCalorieBudgets = async (customerId, dateRange, getRequest) => {
            const keys = this.prepareKeysForCaloriesBudgets(dateRange).map((range) => this.getCalorieBudgetKey(customerId, range));
            return await this.compositeCache.get(keys, getRequest, this.denormalizeBudgets(customerId), this.normalizeBudgets);
        };
        this.denormalizeBudgets = (customerId) => (denormalized) => {
            const map = new Map();
            for (const [range, value] of denormalized.entries()) {
                map.set(this.getCalorieBudgetKey(customerId, range), value);
            }
            return map;
        };
        this.normalizeBudgets = (normalized) => {
            const map = new Map();
            for (const [key, value] of normalized.entries()) {
                const [, , , range] = key.split(".");
                map.set(range, value);
            }
            return map;
        };
        this.prepareKeysForCaloriesBudgets = (dateRange) => {
            const ranges = (0, getDatesOfDateRange_1.getDatesOfDateRange)(dateRange).reduce((acc, date) => {
                const range = (0, RangeUtils_1.weekRangeFromDate)(date);
                acc[`${range.from}~${range.to}`] = null;
                return acc;
            }, {});
            return Object.keys(ranges);
        };
        this.strategy = strategy;
        this.compositeCache = compositeCache;
        this.dateTimeProvider = dateTimeProvider;
        this.dateTimeModifier = dateTimeModifier;
        this.unitMutable = unitMutable;
    }
    lastWeekMonday() {
        return (0, mostRecentStartOfWeek_1.default)(this.dateTimeModifier.modifyDays((0, mostRecentStartOfWeek_1.default)(this.dateTimeProvider.currentDate()), -1));
    }
}
exports.default = NutritionCache;
//# sourceMappingURL=NutritionCache.js.map